import { Leaf, Blocks, Shield } from 'lucide-react';
import { Helmet } from 'react-helmet-async';
import VideoBackground from '../components/home/VideoBackground';

export default function Home() {
  return (
    <div className="relative">
      <Helmet>
        <title>Home | BIOCAP Website</title>
        <meta name="description" content="BIOCAP leads the way in sustainable coastal innovation with modular seawall systems designed to protect coasts and support marine life." />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Helmet>
      <VideoBackground />
      
      {/* Content container with higher z-index */}
      <div className="relative z-30 min-h-[100vh]">
        {/* Hero content */}
        <div className="relative max-w-7xl mx-auto px-8 pt-60 pb-60 min-h-[80vh] flex items-center">
          <div>
            <h1 className="text-5xl font-bold mb-6">
              From Hard Edges to Living Shorelines
            </h1>
            <p className="text-xl text-gray-700 max-w-2xl mb-12">
              A modular tile system for protecting coastlines and supporting marine ecosystems
            </p>
            <div className="flex gap-4">
              <button 
                className="bg-[#005E6E] text-white px-8 py-3 rounded-lg text-lg font-semibold hover:bg-[#004957] transition-colors shadow-md" 
                onClick={() => window.location.href = '/map'}
              >
                Explore Now
              </button>
              <button 
                className="bg-white/80 backdrop-blur-sm text-[#005E6E] px-8 py-3 rounded-lg text-lg font-semibold hover:bg-white transition-colors shadow-md"
                onClick={() => window.location.href = '/project/research'}
              >
                Learn More
              </button>
            </div>
          </div>
        </div>

        {/* Features Section with gradient background */}
        <div className="relative">
          {/* Background gradient */}
          <div className="absolute inset-0 bg-white" />
          
          {/* Content */}
          <div className="relative py-24 max-w-7xl mx-auto px-8">
            <h2 className="text-4xl font-bold text-center mb-16">
              Key Features
            </h2>
            <div className="grid md:grid-cols-3 gap-12">
              {[
                {
                  icon: <Leaf className="h-14 w-14 text-teal-500" />,
                  title: 'Biodiversity Support',
                  description:
                    'Designed to create optimal habitats for marine life, promoting ecosystem diversity',
                },
                {
                  icon: <Blocks className="h-14 w-14 text-teal-500" />,
                  title: 'Modular Design',
                  description:
                    'Flexible, scalable solutions that adapt to different coastal environments',
                },
                {
                  icon: <Shield className="h-14 w-14 text-teal-500" />,
                  title: 'Coastal Protection',
                  description:
                    'Enhanced structural integrity for superior coastal defense',
                },
              ].map((feature, index) => (
                <div
                  key={index}
                  className="text-center p-8 rounded-2xl bg-white shadow-lg hover:shadow-xl transition-shadow"
                >
                  <div className="flex justify-center mb-6">{feature.icon}</div>
                  <h3 className="text-2xl font-semibold mb-4">
                    {feature.title}
                  </h3>
                  <p className="text-gray-600 text-lg leading-relaxed">
                    {feature.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
} 